module.exports = __webpack_public_path__ + "img/chart.040bd425.svg";